import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'ejot',
} as IModuleProps;
